module.exports = __webpack_public_path__ + "img/stressed.8a77deea.gif";